<template>
  <div style="min-width:1280px;">
    <Header />
    <router-view />
  </div>
</template>
<script>
import Header from "./header";
export default {
  name: "index",
  components: {
    Header,
  },
};
</script>



// WEBPACK FOOTER //
// src/page/index.vue